import React from 'react';
import { EffectStatus } from '../types';
import './ActiveEffectsDisplay.css';

interface ActiveEffectsDisplayProps {
    effects: EffectStatus[];
    variant?: 'compact' | 'inline' | 'full';
}

const ActiveEffectsDisplay: React.FC<ActiveEffectsDisplayProps> = ({
    effects,
    variant = 'compact'
}) => {
    if (effects.length === 0) {
        return null;
    }

    const formatEffect = (effect: EffectStatus) => {
        const isPositive = effect.description.startsWith('+');
        return {
            ...effect,
            isPositive
        };
    };

    const formattedEffects = effects.map(formatEffect);

    if (variant === 'compact') {
        return (
            <div className="active-effects active-effects--compact">
                {formattedEffects.map((effect, index) => (
                    <div
                        key={index}
                        className={`effect-pill ${effect.isPositive ? 'positive' : 'negative'}`}
                    >
                        <span className="effect-description">{effect.description}</span>
                        <span className="effect-source">({effect.source_card})</span>
                    </div>
                ))}
            </div>
        );
    }

    if (variant === 'inline') {
        return (
            <div className="active-effects active-effects--inline">
                {formattedEffects.map((effect, index) => (
                    <span
                        key={index}
                        className={`effect-inline ${effect.isPositive ? 'positive' : 'negative'}`}
                    >
                        <span className="effect-icon">{effect.isPositive ? '✓' : '•'}</span>
                        <span className="effect-text">
                            {effect.description} ({effect.source_card})
                        </span>
                    </span>
                ))}
            </div>
        );
    }

    // variant === 'full'
    return (
        <div className="active-effects active-effects--full">
            <div className="effects-header">Active Modifiers</div>
            {formattedEffects.map((effect, index) => (
                <div
                    key={index}
                    className={`effect-row ${effect.isPositive ? 'positive' : 'negative'}`}
                >
                    <span className="effect-icon">{effect.isPositive ? '✓' : '•'}</span>
                    <span className="effect-description">{effect.description}</span>
                    <span className="effect-source">from {effect.source_card}</span>
                    {effect.remaining && (
                        <span className="effect-remaining">({effect.remaining})</span>
                    )}
                </div>
            ))}
        </div>
    );
};

export default ActiveEffectsDisplay;
